"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseComponentEntity = void 0;

var _mobxUtils = require("../_helpers/mobx-utils");

class BaseComponentEntity {
  constructor() {
    this.vid = (0, _mobxUtils.generateUniqueViewId)();
  }

}

exports.BaseComponentEntity = BaseComponentEntity;